<template>
    <div class="doc-page">
        <header class="doc-page__hero">
            <div class="doc-page__inner">
                <div v-if="eyebrow" class="doc-page__eyebrow">{{ eyebrow }}</div>
                <h1>{{ title }}</h1>
                <p v-if="subtitle">{{ subtitle }}</p>
            </div>
        </header>
        <div class="doc-page__inner">
            <article class="doc-page__body">
                <slot />
            </article>
            <slot name="after" />
        </div>
    </div>
</template>

<script>
// Reading layout for long text pages (terms, privacy policy)
export default {
    name: 'DocumentPage',
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: '' },
        eyebrow: { type: String, default: '' }
    }
}
</script>

<style scoped>
.doc-page {
    padding-bottom: 64px;
    color: #1b2f5a;
}

.doc-page__hero {
    padding: 48px 18px 72px;
    background: linear-gradient(135deg, #1b2f5a 0%, #2c4a86 100%);
    color: #fff;
}

.doc-page__inner {
    max-width: 880px;
    margin: 0 auto;
    padding: 0 18px;
}

.doc-page__hero .doc-page__inner {
    padding: 0;
}

.doc-page__eyebrow {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.7);
}

.doc-page__hero h1 {
    margin: 8px 0 0;
    font-size: clamp(28px, 4vw, 40px);
    font-weight: 700;
    line-height: 1.2;
}

.doc-page__hero p {
    margin: 10px 0 0;
    font-size: 17px;
    color: rgba(255, 255, 255, 0.85);
}

.doc-page__body {
    margin-top: -40px;
    padding: 40px 48px;
    background: #fff;
    border: 1px solid rgba(27, 47, 90, 0.1);
    border-radius: 18px;
    box-shadow: 0 12px 32px rgba(27, 47, 90, 0.1);
    font-size: 16px;
    line-height: 1.75;
    overflow-wrap: anywhere;
}

/* the text was pasted from a word processor: tidy its markup */
.doc-page__body ::v-deep p {
    margin: 0 0 1em;
}

.doc-page__body ::v-deep p:empty,
.doc-page__body ::v-deep br + br {
    display: none;
}

.doc-page__body ::v-deep ul {
    margin: 0 0 1.2em;
    padding-left: 22px;
}

.doc-page__body ::v-deep li {
    margin-bottom: 0.5em;
}

.doc-page__body ::v-deep li::marker {
    color: #ad282d;
}

.doc-page__body ::v-deep h2 {
    margin: 1.8em 0 0.6em;
    padding-top: 1.2em;
    border-top: 1px solid rgba(27, 47, 90, 0.1);
    font-size: 21px;
    font-weight: 700;
    line-height: 1.3;
}

.doc-page__body ::v-deep h2:first-child {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
}

.doc-page__body ::v-deep a {
    color: #ad282d;
}

.doc-page__body ::v-deep .doc-callout {
    margin: 0 0 1.4em;
    padding: 18px 22px;
    border-left: 4px solid #ad282d;
    border-radius: 12px;
    background: rgba(173, 40, 45, 0.06);
}

.doc-page__body ::v-deep .doc-callout strong {
    display: block;
    margin-bottom: 4px;
    color: #8f1f23;
}

@media (max-width: 700px) {
    .doc-page__hero {
        padding: 32px 18px 60px;
    }

    .doc-page__body {
        padding: 24px 20px;
        border-radius: 14px;
        font-size: 15px;
    }
}
</style>
